import { Link } from "react-router-dom";

/** 测评大厅：双列卡片长廊（爱情地图下的子栏目） */
export const LOVE_ASSESS_ITEMS = [
  {
    key: "map",
    title: "AI爱情地图",
    bannerTitle: "认识自己，看见期待",
    bannerSub: "自我认知卡 + 择偶期望卡，画出你的爱情坐标",
    cta: "点击开始 ▶",
    price: "免费",
    gradient: "from-rose-400 via-fuchsia-500 to-violet-500",
    accent: "#fff",
    icon: "❤️",
  },
  {
    key: "languages",
    title: "爱的五种语言",
    bannerTitle: "你最能感受到爱的方式是？",
    bannerSub: "30道迫选题，找到你的主要爱语",
    cta: "点击测试 ▶",
    price: "免费",
    gradient: "from-amber-400 via-rose-400 to-violet-500",
    accent: "#fff",
    icon: "💬",
  },
  {
    key: "fruit",
    title: "测测你的爱情性格水果是什么",
    bannerTitle: "测测你的爱情性格水果是什么？",
    bannerSub: "三分钟爱情性格测试，找到你的最佳匹配",
    cta: "点击测试 ▶",
    price: "免费",
    gradient: "from-teal-300 via-cyan-200 to-emerald-200",
    accent: "#0f766e",
    darkText: true,
    icon: "🍒",
  },
  {
    key: "planet",
    title: "漂流星球",
    bannerTitle: "模糊坐标上的漂流瓶",
    bannerSub: "公开城市位置，在地图上遇见同城与远方，投一封可被接住的信",
    cta: "进入星球 ▶",
    price: "免费",
    gradient: "from-teal-800 via-cyan-700 to-slate-800",
    accent: "#fff",
    icon: "🪐",
    href: "/planet",
  },
];

function AssessCardInner({ item }) {
  return (
    <>
      <div
        className={`relative h-36 sm:h-44 bg-gradient-to-br ${item.gradient} p-3 flex flex-col justify-between`}
      >
        <div>
          <p
            className={`text-sm sm:text-base font-extrabold leading-snug ${
              item.darkText ? "text-teal-800" : "text-white"
            }`}
          >
            {item.bannerTitle}
          </p>
          <p
            className={`text-[10px] sm:text-xs mt-1.5 leading-relaxed line-clamp-2 ${
              item.darkText ? "text-teal-700/80" : "text-white/85"
            }`}
          >
            {item.bannerSub}
          </p>
        </div>
        <span
          className={`self-start text-[10px] sm:text-xs px-2.5 py-1 rounded-full font-medium ${
            item.darkText
              ? "bg-teal-700 text-white"
              : "bg-black/25 text-white backdrop-blur-sm"
          }`}
        >
          {item.cta}
        </span>
        <div className="absolute right-2 bottom-2 text-3xl sm:text-4xl opacity-90 pointer-events-none">
          {item.icon}
        </div>
      </div>
      <div className="p-3 space-y-3 min-h-[4.5rem] flex flex-col justify-between">
        <h2 className="text-sm font-bold text-gray-800 leading-snug line-clamp-2">
          {item.title}
        </h2>
        <p className="text-rose-500 font-semibold text-sm">{item.price}</p>
      </div>
    </>
  );
}

const cardClass =
  "text-left bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 hover:shadow-lg hover:-translate-y-0.5 transition active:scale-[0.99] block";

export default function LoveAssessGallery({ onSelect }) {
  return (
    <section className="space-y-5 animate-[fadeIn_0.35s_ease]">
      <header className="space-y-1">
        <h1 className="text-2xl font-extrabold text-gray-800">测评</h1>
        <p className="text-sm text-gray-500">选一个开始，认识自己的爱情模样</p>
      </header>

      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {LOVE_ASSESS_ITEMS.map((item) =>
          item.href ? (
            <Link key={item.key} to={item.href} className={cardClass}>
              <AssessCardInner item={item} />
            </Link>
          ) : (
            <button
              key={item.key}
              type="button"
              onClick={() => onSelect(item.key)}
              className={cardClass}
            >
              <AssessCardInner item={item} />
            </button>
          )
        )}
      </div>
    </section>
  );
}
